<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="130px"
        v-loading="loading">

        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="deviceId" label="设备名称">
            <!-- <el-input v-model="formData.deviceId" placeholder="请输入设备ID"></el-input> -->
            <el-select v-model="formData.deviceId" clearable filterable placeholder="请选择设备">
            <el-option v-for="(item, index) of deviceList" :value="item.deviceId" :label="item.deviceName"
              :key="index"></el-option>
          </el-select>
          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="currentStatus" label="当前状态">
              <el-select v-model="formData.currentStatus" clearable filterable placeholder="请选择当前状态">
            <el-option v-for="(item, index) of statusArr" :value="item.value" :label="item.label"
              :key="index"></el-option>
          </el-select>
          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="checkResult" label="检查结果">
              <el-select v-model="formData.checkResult" clearable filterable placeholder="请选择检查结果">
            <el-option v-for="(item, index) of resultArr" :value="item.value" :label="item.label"
              :key="index"></el-option>
          </el-select>
          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="manager" label="管理人">
              <el-select v-model="formData.manager" clearable filterable placeholder="请选择检查结果">
            <el-option v-for="(item, index) of userList" :value="item.userId" :label="item.userName"
              :key="index"></el-option>
          </el-select>
          </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item prop="remark" label="备注">
            <el-input type="textarea" v-model="formData.remark" placeholder="请输入备注"></el-input>

          </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <div class="row-wrap">

                <div class="images-wrap" v-for="(item, index) of $attachmentFiles(formData.fileList)" :key="index">
                  <i class="el-icon-error close-icon" @click="delImage(formData.fileList.indexOf(item))"></i>
                  <el-image style="width: 100%; height: 100%" :src="item.filePrefix + item.fileUrl"
                    :preview-src-list="fileImgUrl" fit="cover" />
                </div>

                <el-upload class="upload-demo" :show-file-list="false" :action="$apis.common.uploadUrl"
                  :on-success="handleSuccess" :before-upload="beforeUpload" list-type="picture-card">
                  <i class="el-icon-plus"></i>
                  <div slot="tip" class="el-upload__tip">
                    图片大小不能超过10MB~
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>

export default {
  name: 'equipmentLedgerAdd',

  data () {
    return {
      formData: {
        deviceId: '',
        currentStatus: '',
        manager: '',
        managerName: '',
        checkResult: '',
        remark: '',
        fileList: []
      },

      rules: {

        deviceId: [
          {
            required: true,
            message: '请输入设备ID',
            trigger: ['blur', 'change']
          }
        ],
        currentStatus: [
          {
            required: true,
            message: '请选择当前状态',
            trigger: ['blur', 'change']
          }
        ],
        manager: [
          {
            required: true,
            message: '请选择管理人',
            trigger: ['blur', 'change']
          }
        ],
        checkResult: [
          {
            required: true,
            message: '请选择检查结果',
            trigger: ['blur', 'change']
          }
        ]

      },
      loading: false,
      userList: [],
      statusArr: [
        {
          label: '闲置',
          value: '1'
        },
        {
          label: '运行',
          value: '2'
        },
        {
          label: '维护',
          value: '3'
        }
      ],
      // 正常/异常

      resultArr: [
        {
          label: '正常',
          value: '1'
        },
        {
          label: '异常',
          value: '2'
        }

      ],
      deviceList: []

    }
  },
  created () {
    this.loadDev()
    this.loadUser()
    if (this.recordId) {
      this.loadData()
    }
  },
  computed: {
    recordId () {
      return this.$route.query.recordId
    },
    fileImgUrl () {
      const arr = this.$attachmentFiles(this.formData.fileList).map(item => {
        return item.filePrefix + item.fileUrl
      })
      return arr
    }

  },
  methods: {
    loadUser() {
      this.$axios.get(this.$apis.patrolProblemReport.selectIparkUserByRole, {
        userType: '1'
      }).then(res => {
        this.userList = res || []
      })
    },
    loadDev() {
      this.$axios.get(this.$apis.specialEquipment.selectPaSpecialEquipmentByPage, {

      }).then(res => {
        this.deviceList = res.list || []
      })
    },

    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.equipmentLedger.selectPaEquipmentLedgerByRecordId, {
          params: { recordId: this.recordId }
        })
        .then(res => {
          res.fileList = res.fileList ? res.fileList : []

          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    },

    handleSuccess (res) {
      this.formData.fileList.push(res.data)
    },

    delImage (index) {
      this.formData.fileList.splice(index, 1)
    },
    beforeUpload (file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
      }
      const isLt10M = file.size / 1024 / 1024 < 20
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB')
      }
      return isImage && isLt10M
    },

    submit () {
      this.$refs.form
        .validate()
        .then(() => {
          this.loading = true

          let url = this.$apis.equipmentLedger.insertPaEquipmentLedger
          if (this.recordId) {
            url = this.$apis.equipmentLedger.updatePaEquipmentLedger
          }

          this.$axios.post(url, { ...this.formData }).then(() => {
            this.$router.back()
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}

.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  margin-right: 14px;

  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
}
</style>
